import DigitalAssetWithCountAndFileNameModelBase from '../_generated/modelBases/digital-asset-with-count-and-file-name-model-base';

export default class DigitalAssetWithCountAndFileNameModel extends DigitalAssetWithCountAndFileNameModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
